//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamEleServerDiskDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-11-08                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=482.70.X1
//AdtGeneratorConfig:[ T:(wflsdis) V1:(disk_name,poznamka,vel_max,vel_free,vel_min,files_max,dir_vel_max,dir_vel_min,priorita,dat_zmena,disk_name_fyz,typ_db,db_name,servername32) V2:(server_name,typ_media,aktivita,priz_ro,zmenu_prov,typ_zip,ixs_ulz) K1:(f_wflsdis_ser) K2:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamZastupDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamEleServerDiskDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - server_name */
            public server_name: string;
            /** PK - disk_name */
            public disk_name: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GEleServerDiskDto>;

        /** vytvo�it form�t seznamu - definice sloupc�, napdpis�, ���ek atd... */
        static createGridFormat(that: GContentType<SeznamEleServerDiskDesigner>): Gordic.Data.GridFormat {

            var columnsDefinition = this.createGridFormatBase(that);

            columnsDefinition
                .addTextColumn({
                                    name: "server_name_txt",
                                    caption: "jres:30028705", //RC 30028705 : Jm�no serveru elektronick�ho �lo�i�t�
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "disk_name",
                                    caption: "jres:30027711", //RC 30027711 : Jm�no disku elektronick�ho �lo�i�t�
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "poznamka",
                                    caption: "jres:29930689", //RC 29930689 : Pozn�mka
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "typ_media_txt",
                                    caption: "jres:30027724", //RC 30027724 : Typ m�dia
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "aktivita_txt",
                                    caption: "jres:29924152", //RC 29924152 : Aktivita
                                    width: 300,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "vel_max",
                                    caption: "jres:30027727", //RC 30027727 : V�choz� velikost disku
                                    width: 150,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "vel_free",
                                    caption: "jres:30027726", //RC 30027726 : Velikost voln�
                                    width: 150,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "vel_min",
                                    caption: "jres:30027728", //RC 30027728 : Velikost minim�ln�
                                    width: 150,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "files_max",
                                    caption: "jres:30027714", //RC 30027714 : Maxim�ln� po�et soubor�
                                    width: 150,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "dir_vel_max",
                                    caption: "jres:30027709", //RC 30027709 : Maxim�ln� velikost adres��e
                                    width: 150,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "dir_vel_min",
                                    caption: "jres:30027710", //RC 30027710 : Minim�ln� voln� m�sto v adres��i
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "priz_ro_txt",
                                    caption: "jres:30027719", //RC 30027719 : Pouze pro �ten�
                                    width: 300,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "priorita",
                                    caption: "jres:30027718", //RC 30027718 : Priorita disku
                                    width: 150,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_zmena",
                                    caption: "jres:29930674", //RC 29930674 : Zm�n�no
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "zmenu_prov_txt",
                                    caption: "jres:29930694", //RC 29930694 : Zm�nil
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "typ_zip_txt",
                                    caption: "jres:30027725", //RC 30027725 : Zp�sob ulo�en�
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "disk_name_fyz",
                                    caption: "jres:30027712", //RC 30027712 : Fyzick� jm�no disku
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "ixs_ulz_txt",
                                    caption: "jres:30027716", //RC 30027716 : Skupina �lo�i��
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "typ_db",
                                    caption: "jres:29928893", //RC 29928893 : Typ DB stroje
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "db_name",
                                    caption: "jres:29928817", //RC 29928817 : Jm�no datab�ze
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "servername32",
                                    caption: "jres:30027722", //RC 30027722 : Jm�no DB serveru
                                    width: 300,
                                    fragment: ""
                })

            return columnsDefinition;
        } // createGridFormat

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamEleServerDiskDesigner>, server_name: string): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that);
            v_form
                .addRow({
                    label: "jres:30028705" //RC 30028705 : Jm�no serveru elektronick�ho �lo�i�t�
                })
                .addField("gselectbox", Gordic.Prefabs.Select.wflsser(), {
                    dropdown: true,
                    name: "server_name",
                    model: "model.server_name=value.server_name",
                    initialValue: { server_name: server_name },
                    disabled: true
                });
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction);    // true - s automatick�m na�ten�m seznamu p�i jeho prvn�m zobrazen�

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamEleServerDiskDesigner>): Forms.Form {
            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamEleServerDiskDesigner>, ev, ctx): any {
            var filterObj = {
                server_name: SeznamBase.filterContains(ctx.filter, "server_name")
            }
            that.view = new Gordic.Isl.View(that.isl.EleServerDisk.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamEleServerDiskDesignerInit
         * 
         * @param {GContentType<SeznamEleServerDiskDesigner>} that
         */
        static SeznamEleServerDiskDesignerInit(that: GContentType<SeznamEleServerDiskDesigner>, server_name: string) {
            that.filter = this.createFilter(that, server_name);
            that.gridFormat = this.createGridFormat(that);
            that.gridSearchColumns = "server_name_txt,disk_name,poznamka,typ_media_txt,aktivita_txt,vel_max,vel_free,vel_min,files_max,dir_vel_max,dir_vel_min,priz_ro_txt,priorita,dat_zmena,zmenu_prov_txt,typ_zip_txt,disk_name_fyz,ixs_ulz_txt,typ_db,db_name,servername32".split(",");
            this.LoadData(that, server_name);

        } // SeznamEleServerDiskDesignerInit

        static LoadData(that: GContentType<SeznamEleServerDesigner>, server_name: string) {
            var filterObj: any = {}
            if (server_name) {
                new Gordic.Data.Readers.Wflsser().getData({ server_name: server_name }).done((o) => {
                    that.filter.findFields("server_name").gfield("setInitial", o[0]);
                })
                filterObj.server_name = server_name;
            }
            that.view = new Gordic.Isl.View(that.isl.EleServerDisk.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } 

    }
}
